import React from "react";

import animations from "./components/animations";
import hamburger from "./components/hamburger";
import heroSlide from "./components/hero-slide";
import values from "./components/values";
import whatsOn from "./components/whats-on";
import pathways from "./components/pathways";
import mobileSlider from "./components/mobile-slider";
import glightbox from "./components/glightbox";
import people from "./components/people";
import accordion from "./components/accordion";
import recentNews from "./components/recent-news";
import relatedNews from "./components/related-news";
import infiniteScroll from "./components/infinite-scroll";
import emailSignup from "./components/emailSignup";
import faqs from "./components/faqs";
import search from "./components/search";
import howHire from "./components/how-hire";
import videos from "./components/videos";
import videoLandingPage from "./components/video-landing-page";
import quizList from "./components/quiz-list";
import lazyload from "./components/lazyload";

import app from './app/app';

animations();
hamburger();
heroSlide();
emailSignup();

document.addEventListener("DOMContentLoaded", () => {
    lazyload();
    app();
});

window.addEventListener('DOMContentLoaded', () => { // load before
    values();
    whatsOn();
    pathways();
    people();
    mobileSlider();
    glightbox();
    accordion();
    recentNews();
    relatedNews();
    infiniteScroll();
    faqs();
    search();
    howHire();
    videos();
    videoLandingPage();
    quizList();
    // quizPage();
});


